<template>
  <div>
    <b-modal 
      centered 
      :id="id"
      :title="title" 
      class="modal-primary" 
      :size="isVariables ? 'md' : 'xl'"
      header-bg-variant="primary"
      ok-variant="primary"
      ok-only
      @ok="modalClick"
      @show="modalShow"
    >
      <template #modal-ok>{{isVariables ? 'Ок' : 'Закрыть'}}</template>
        
      <div v-if="isVariables" >
        <b-input-group v-for="item in variables" :key="item.Name" class="mb-1 mr-1" :prepend="item.Alias">
          <b-form-input 
            v-if="item.Type.includes('System.Byte') || item.Type.includes('System.UInt16') || item.Type.includes('System.UInt32') || item.Type.includes('System.UInt64')"
            type="number"
            min="0"
            v-model="item.Value"
            :style="!item.Description || (item.Description.includes('required') && item.Value) ? '' : 'border-style: solid; border-radius: 4px; border-width: 2px; border-color:red'"
          />
          <b-form-input 
            v-else-if="item.Type.includes('System.SByte') || item.Type.includes('System.Int16') || item.Type.includes('System.Int32') || item.Type.includes('System.Int64')"
            type="number"
            v-model="item.Value"
            :style="!item.Description || (item.Description.includes('required') && item.Value) ? '' : 'border-style: solid; border-radius: 4px; border-width: 2px; border-color:red'"
          />
          <b-form-input 
            v-else-if="item.Type.includes('System.Single') || item.Type.includes('System.Double') || item.Type.includes('System.Decimal')"
            type="number"
            v-model="item.Value"
            :style="!item.Description || (item.Description.includes('required') && item.Value) ? '' : 'border-style: solid; border-radius: 4px; border-width: 2px; border-color:red'"
          />
          <b-form-input 
            v-else-if="item.Type.includes('System.DateTime')"
            type="date"
            v-model="item.Value"
            :style="!item.Description || (item.Description.includes('required') && item.Value) ? '' : 'border-style: solid; border-radius: 4px; border-width: 2px; border-color:red'"
          />          
          <b-form-checkbox
            v-else-if="item.Type.includes('System.Boolean')"
            class="mt-1 ml-2"
            switch
            size="lg"
            v-model="item.Value"
          />          
          
          <template v-else>
            <b-form-select 
              v-if="getListVariable(item) !== null"
              :options="getListVariable(item)"
              type="text"
              v-model="item.Value"
              :style="!item.Description || (item.Description.includes('required') && item.Value) ? '' : 'border-style: solid; border-radius: 4px; border-width: 2px; border-color:red'"
            />
            <b-form-input
              v-else
              type="text"
              v-model="item.Value"
              :style="!item.Description || (item.Description.includes('required') && item.Value) ? '' : 'border-style: solid; border-radius: 4px; border-width: 2px; border-color:red'"
            />
          </template>
          
          <b-overlay :show="variableBusy" no-wrap></b-overlay>
        </b-input-group>        
      </div>

      <viewer 
        v-else
        :title="title"
        :fileName="title"
        :report="reportInner"
        :dataSets="dataSets"
      />
    </b-modal>
  </div>
</template>

<script>
  import Viewer from './Viewer.vue'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import CompaniesService from '@/services/web/companies.service'
  import UsersService from '@/services/web/users.service'

export default {
  name: 'report-viewer-modal',

  components: { Viewer },

  data: function() {
    return { 
      isVariables: false,
      reportObj: {},
      reportInner: null,
      variables: [],
      companies: [],      
      users: [],
      companiesBusy: false,
      usersBusy: false,
    }
  },

  props: {
    id: {
      type: String,
      default: 'report-viewer-modal'
    },
    title: {
      type: String,
      default: null
    },
    reportType: {
      type: String,
      default: null
    },
    report: {
      type: String,
      default: null
    },
    dataSets: {
      type: Array,
      default:  () => []
    },
    customVariables: {
      type: Array,
      default:  () => []
    },
  },

  watch: {
    report() {
      this.checkVariables()
    },

    dataSets() {
      this.checkVariables()
    }
  },

  computed: {
    variableBusy() {
      return this.companiesBusy || this.usersBusy
    },
    ...mapGetters(['idCompany', 'idUser', 'idRole', 'companyTypePublicCode', 'isAdmin', 'isSuperAdmin', 'idCompany'])
  },

  methods: {
    checkVariables() {
      this.reportObj = JSON.parse(this.report)

      if (!this.reportObj) return

      if(this.customVariables.length > 0) {
        Object.keys(this.reportObj.Dictionary.Variables).forEach(a => {
          this.customVariables.forEach(cVar => {            
            if (this.reportObj.Dictionary.Variables[a].Name === cVar.name) {
              this.reportObj.Dictionary.Variables[a].Value = cVar.value
            }
          })
        })
      }

      this.variables = []
      if(this.reportObj.Dictionary && this.reportObj.Dictionary.Variables) {
        Object.keys(this.reportObj.Dictionary.Variables).forEach(a => {          
          if (this.reportObj.Dictionary.Variables[a].AllowUseAsSqlParameter && !(this.reportObj.Dictionary.Variables[a].Description && this.reportObj.Dictionary.Variables[a].Description.includes('private'))) {
            this.reportObj.Dictionary.Variables[a].Value = null
            this.variables.push(this.reportObj.Dictionary.Variables[a])

            if (this.reportObj.Dictionary.Variables[a].Name === 'IdCompanySelect') {
              this.getCompanies()
            }

            if (this.reportObj.Dictionary.Variables[a].Name === 'IdUserSelect') {
              this.getUsers()
            }
          }
        })
      }

      if((this.dataSets && this.dataSets.length>0) || this.variables.length <= 0) {
        this.reportInner = JSON.stringify(this.reportObj) //this.report
        this.isVariables = false
        return
      }

      this.isVariables = true
    },

    modalClick(event) {
      if (!this.isVariables) {
        return
      }

      let isValid = true
      this.variables.forEach(item => {
        //console.log(item)
        if (item.Description && item.Description.includes('required') && !item.Value) {
          //console.log(item)
          isValid = false
        }
      })

      if(!isValid) {
        event.preventDefault()
        return
      }

      //console.log(this.reportObj)
      this.reportInner = JSON.stringify(this.reportObj)

      var reportSetVars = new window.Stimulsoft.Report.StiReport()
      reportSetVars.load(this.reportInner)

      this.reportSetVariables(reportSetVars, false)
      this.reportInner = reportSetVars.saveToJsonString()

      if (this.reportType === 'excell') {
        var report = new window.Stimulsoft.Report.StiReport()
        report.load(this.reportInner)
        //console.log(this.reportInner)
        let reportfileName = this.title
        report.renderAsync(function () {
          report.exportDocumentAsync(function (data) {
            Stimulsoft.System.StiObject.saveAs(data, reportfileName + ".xlsx", "application/xlsx")
          }, Stimulsoft.Report.StiExportFormat.Excel2007)
        })
        return
      }

      if (this.reportType === 'word') {
        var report = new window.Stimulsoft.Report.StiReport()
        report.load(this.reportInner)
        let reportfileName = this.title
        report.renderAsync(function () {
          report.exportDocumentAsync(function (data) {
            Stimulsoft.System.StiObject.saveAs(data, reportfileName + ".doc", "application/doc")
          }, Stimulsoft.Report.StiExportFormat.Word2007)
        })
        return
      }

      if (this.reportType === 'pdf') {
        var report = new window.Stimulsoft.Report.StiReport()
        report.load(this.reportInner)
        let reportfileName = this.title
        report.renderAsync(function () {
          report.exportDocumentAsync(function (data) {
            Stimulsoft.System.StiObject.saveAs(data, reportfileName + ".pdf", "application/pdf")
          }, Stimulsoft.Report.StiExportFormat.Pdf)
        })
        return
      }

      this.isVariables = false      
      event.preventDefault()
    },

    modalShow() {
      this.checkVariables()
    },

    getCompanies() {
      if (this.companies.length > 0) return
      //console.log('getCompanies')
      this.companiesBusy = true
      CompaniesService.get(null, null, null, 1, 100)
      .then(result => {
        //console.log('getCompaniesFinished')
        this.companies = []
        if (result.data && result.data.data) {
          result.data.data.forEach(item => {
            this.companies.push({text: item.name, value: item.id})
          })
        }
      })
      .finally(() => {
        this.companiesBusy = false
      })
    },

    getUsers() {
      if (this.users.length > 0) return
      //console.log('getUsers')
      this.usersBusy = true
      return UsersService.get(null, this.idCompany, false, null, null, null, 1, 100)
      .then(result => {
        //console.log('getUsersFinished')
        this.users = []
        if (result.data && result.data.data) {
          result.data.data.forEach(item => {
            this.users.push({text: item.userFullNameWithLogin, value: item.id})
          })
        }
      })
      .finally(() => {
        this.usersBusy = false
      })
    },

    getListVariable(item) {
      switch(item.Name) {
        case 'IdCompanySelect':
          if (this.companies.length === 1) {
            item.Value = this.companies[0].value
          }
          return this.companies

        case 'IdUserSelect':
        if (this.users.length === 1) {
            item.Value = this.users[0].value
          }
          return this.users

        default:
          return null
      }
    },
  },

  

  mounted() { 
    //this.getCompanies()
    //this.getUsers()
  }
}

</script>

